/* src/constants/timezoneData.js */
export const TIMEZONE_OPTIONS = [
    // Major US/Canada timezones
    { value: 'America/New_York', label: 'Eastern Time (ET) - New York' },
    { value: 'America/Chicago', label: 'Central Time (CT) - Chicago' },
    { value: 'America/Denver', label: 'Mountain Time (MT) - Denver' },
    { value: 'America/Los_Angeles', label: 'Pacific Time (PT) - Los Angeles' },
    { value: 'America/Anchorage', label: 'Alaska Time - Anchorage' },
    { value: 'Pacific/Honolulu', label: 'Hawaii Time - Honolulu' },
    { value: 'America/Toronto', label: 'Eastern Time - Toronto' },
    { value: 'America/Vancouver', label: 'Pacific Time - Vancouver' },
    
    // Major European timezones
    { value: 'Europe/London', label: 'GMT/BST - London' },
    { value: 'Europe/Paris', label: 'Central European Time - Paris' },
    { value: 'Europe/Berlin', label: 'Central European Time - Berlin' },
    { value: 'Europe/Athens', label: 'Eastern European Time - Athens' },
    { value: 'Europe/Moscow', label: 'Moscow Time - Moscow' },
    
    // Major Asian timezones
    { value: 'Asia/Tokyo', label: 'Japan Standard Time - Tokyo' },
    { value: 'Asia/Shanghai', label: 'China Standard Time - Shanghai' },
    { value: 'Asia/Singapore', label: 'Singapore Time' },
    { value: 'Asia/Dubai', label: 'Gulf Standard Time - Dubai' },
    { value: 'Asia/Kolkata', label: 'India Standard Time - Mumbai' },
    
    // Australia/NZ
    { value: 'Australia/Sydney', label: 'Australian Eastern Time - Sydney' },
    { value: 'Australia/Perth', label: 'Australian Western Time - Perth' },
    { value: 'Pacific/Auckland', label: 'New Zealand Time - Auckland' },
    
    // UTC
    { value: 'UTC', label: 'Coordinated Universal Time (UTC)' }
];